import React from 'react';
import ReactDOM from 'react-dom';
import { FiCalendar, FiMessageSquare, FiMoreVertical, FiPlus, FiSend, FiUser, FiX } from 'react-icons/fi';
import styles from '../Dashboard.module.css';
import * as utils from '../../../utils/utils';
import HQDialog from '../../HQDialog/HQDialog';

export default class DashboardChatter extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			errorText: '',
			isLoadingChatters: false,
			isLoadingMoreChatters: false,
			isSavingChatter: false,
			isSendingReplyIDs: [],
			chatterErrorText: '',
			saveChatterErrorText: '',
			isAddChatterDialogOpen: false,
			newChatterText: '',
			replyTextByChatterID: {},
			openReplyComposerID: 0,
			openChatterMenuID: 0,
			openReplyChatterMenuID: 0,
			deletingChatterIDs: [],
			deletingReplyChatterIDs: [],
			confirmDeleteChatterID: 0,
			confirmDeleteReplyChatterID: 0,
			confirmDeleteReplyParentChatterID: 0,
			chatterList: [],
			chatterOffset: 0,
			hasMoreChatters: true,
		};

		this.chatterMenuRefs = {};
		this.replyChatterMenuRefs = {};
	}

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		document.addEventListener('mousedown', this.onDocumentPointerDown);
		document.addEventListener('touchstart', this.onDocumentPointerDown);

		this.loadChatterData();
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.onDocumentPointerDown);
		document.removeEventListener('touchstart', this.onDocumentPointerDown);
	}

	getChatterID = (item) => {
		if (!item) {
			return null;
		}

		const chatterID = Number(item.chatterId);
		if (!Number.isInteger(chatterID) || chatterID <= 0) {
			return null;
		}

		return chatterID;
	};

	isChatterDeleting = (chatterID) => {
		return (this.state.deletingChatterIDs || []).includes(chatterID);
	};

	setChatterMenuRef = (chatterID, node) => {
		if (!Number.isInteger(chatterID) || chatterID <= 0) {
			return;
		}

		if (node) {
			this.chatterMenuRefs[chatterID] = node;
			return;
		}

		delete this.chatterMenuRefs[chatterID];
	};

	onDocumentPointerDown = (event) => {
		const openChatterMenuID = Number(this.state.openChatterMenuID);
		const openReplyChatterMenuID = Number(this.state.openReplyChatterMenuID);

		if (Number.isInteger(openChatterMenuID) && openChatterMenuID > 0) {
			const activeChatterMenuRoot = this.chatterMenuRefs[openChatterMenuID];

			if (!activeChatterMenuRoot || !activeChatterMenuRoot.contains(event.target)) {
				this.setState({
					openChatterMenuID: 0,
				});
			}
		}

		if (Number.isInteger(openReplyChatterMenuID) && openReplyChatterMenuID > 0) {
			const activeReplyChatterMenuRoot = this.replyChatterMenuRefs[openReplyChatterMenuID];

			if (!activeReplyChatterMenuRoot || !activeReplyChatterMenuRoot.contains(event.target)) {
				this.setState({
					openReplyChatterMenuID: 0,
				});
			}
		}
	};

	toggleChatterMenu = (chatterID) => {
		this.setState((prevState) => ({
			openChatterMenuID: prevState.openChatterMenuID === chatterID ? 0 : chatterID,
		}));
	};

	setReplyChatterMenuRef = (replyChatterID, node) => {
		if (!Number.isInteger(replyChatterID) || replyChatterID <= 0) {
			return;
		}

		if (node) {
			this.replyChatterMenuRefs[replyChatterID] = node;
			return;
		}

		delete this.replyChatterMenuRefs[replyChatterID];
	};

	toggleReplyChatterMenu = (replyChatterID) => {
		if (!Number.isInteger(replyChatterID) || replyChatterID <= 0) {
			return;
		}

		this.setState((prevState) => ({
			openReplyChatterMenuID: prevState.openReplyChatterMenuID === replyChatterID ? 0 : replyChatterID,
		}));
	};

	formatChatterTimestamp = (value) => {
		if (!value) {
			return 'Just now';
		}

		const parsedDate = new Date(value);
		if (Number.isNaN(parsedDate.getTime())) {
			return 'Just now';
		}

		return parsedDate.toLocaleString([], {
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: '2-digit',
		});
	};

	getDisplayName = (item) => {
		const firstName = item && item.firstName ? String(item.firstName).trim() : '';
		const lastName = item && item.lastName ? String(item.lastName).trim() : '';
		const fullName = `${firstName} ${lastName}`.trim();
		return fullName === '' ? 'Member' : fullName;
	};

	getInitials = (item) => {
		const firstName = item && item.firstName ? String(item.firstName).trim() : '';
		const lastName = item && item.lastName ? String(item.lastName).trim() : '';
		const initials = `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`.toUpperCase();
		return initials === '' ? 'ME' : initials;
	};

	onNewChatterTextChange = (event) => {
		this.setState({
			newChatterText: event.target.value,
		});
	};

	loadChatterData = ({ offset = 0, append = false } = {}) => {
		const userID = utils.getCurrentUserID();
		const normalizedOffset = Number.isInteger(offset) && offset >= 0 ? offset : 0;

		this.setState({
			isLoadingChatters: !append,
			isLoadingMoreChatters: append,
			chatterErrorText: '',
		});

		utils.sendRequest('/chatter/getUserChatter', {
			userID,
			offset: normalizedOffset,
		})
			.then((responseData) => {
				const fetchedChatters = responseData.chatters || [];
				const fetchedCount = fetchedChatters.length;

				this.setState((prevState) => ({
					isLoadingChatters: false,
					isLoadingMoreChatters: false,
					chatterList: append ? [...prevState.chatterList, ...fetchedChatters] : fetchedChatters,
					chatterOffset: append ? prevState.chatterOffset + fetchedCount : fetchedCount,
					hasMoreChatters: fetchedCount === 5,
				}));
			})
			.catch((error) => {
				console.log('chatter load error', error);
				this.setState({
					isLoadingChatters: false,
					isLoadingMoreChatters: false,
					chatterErrorText: 'Could not load chatter right now.',
				});
			});
	};

	loadMoreChatters = () => {
		if (this.state.isLoadingMoreChatters || !this.state.hasMoreChatters) {
			return;
		}

		this.loadChatterData({
			offset: this.state.chatterOffset,
			append: true,
		});
	};

	isReplySending = (chatterID) => {
		return (this.state.isSendingReplyIDs || []).includes(chatterID);
	};

	toggleReplyComposer = (chatterID) => {
		if (!Number.isInteger(chatterID) || chatterID <= 0) {
			return;
		}

		this.setState((prevState) => {
			const shouldOpen = prevState.openReplyComposerID !== chatterID;

			return {
				openReplyComposerID: shouldOpen ? chatterID : 0,
				replyTextByChatterID: shouldOpen
					? {
						...prevState.replyTextByChatterID,
						[chatterID]: prevState.replyTextByChatterID[chatterID] || '',
					}
					: prevState.replyTextByChatterID,
			};
		});
	};

	onReplyTextChange = (chatterID, event) => {
		const value = event && event.target ? event.target.value : '';

		this.setState((prevState) => ({
			replyTextByChatterID: {
				...prevState.replyTextByChatterID,
				[chatterID]: value,
			},
		}));
	};

	onReplySend = (parentChatter) => {
		const parentChatterID = this.getChatterID(parentChatter);

		if (!Number.isInteger(parentChatterID) || parentChatterID <= 0 || this.isReplySending(parentChatterID)) {
			return;
		}

		const currentReplyText = ((this.state.replyTextByChatterID || {})[parentChatterID] || '').trim();

		if (currentReplyText === '') {
			this.setState({
				saveChatterErrorText: 'Please enter a reply before sending.',
			});
			return;
		}

		const currentUserID = utils.getCurrentUserID();
        const firstName = utils.getUserFirstName() || '';
        const lastName = utils.getUserLastName() || '';

		this.setState((prevState) => ({
			isSendingReplyIDs: Array.from(new Set([...(prevState.isSendingReplyIDs || []), parentChatterID])),
			saveChatterErrorText: '',
		}), () => {
			utils.sendRequest('/chatter/saveChatter', {
				chatterText: currentReplyText,
				chatterID: parentChatterID,
			})
				.then((responseData) => {
					const newChatterID = Number(responseData.newChatterID);
					const normalizedNewChatterID = Number.isInteger(newChatterID) && newChatterID > 0 ? newChatterID : Date.now();

					const newReply = {
						chatterId: normalizedNewChatterID,
						userId: currentUserID,
						firstName,
						lastName,
						chatterText: currentReplyText,
						createdAt: new Date().toISOString(),
					};

					this.setState((prevState) => {
						const nextReplyTextByChatterID = {
							...prevState.replyTextByChatterID,
							[parentChatterID]: '',
						};

						const nextChatterList = (prevState.chatterList || []).map((chatter) => {
							if (Number(chatter.chatterId) !== parentChatterID) {
								return chatter;
							}

							const existingReplies = Array.isArray(chatter.replies) ? chatter.replies : [];

							return {
								...chatter,
								replies: [newReply, ...existingReplies],
							};
						});

						return {
							chatterList: nextChatterList,
							replyTextByChatterID: nextReplyTextByChatterID,
							isSendingReplyIDs: (prevState.isSendingReplyIDs || []).filter((id) => id !== parentChatterID),
							openReplyComposerID: 0,
						};
					});
				})
				.catch((error) => {
					console.log('save reply error', error);

					this.setState((prevState) => ({
						isSendingReplyIDs: (prevState.isSendingReplyIDs || []).filter((id) => id !== parentChatterID),
						saveChatterErrorText: error && error.message ? error.message : 'Could not send reply right now. Please try again shortly.',
					}));
				});
		});
	};

	openAddChatterDialog = () => {
		this.setState({
			isAddChatterDialogOpen: true,
			newChatterText: '',
			saveChatterErrorText: '',
		});
	};

	closeAddChatterDialog = () => {
		this.setState({
			isAddChatterDialogOpen: false,
			saveChatterErrorText: '',
		});
	};

	openDeleteChatterDialog = (item) => {
		const chatterID = this.getChatterID(item);

		if (!Number.isInteger(chatterID) || chatterID <= 0 || this.isChatterDeleting(chatterID)) {
			return;
		}

		this.setState({
			openChatterMenuID: 0,
			confirmDeleteChatterID: chatterID,
		});
	};

	closeDeleteChatterDialog = () => {
		this.setState({
			confirmDeleteChatterID: 0,
		});
	};

	onDeleteChatterDialogPrimaryClick = () => {
		const chatterID = Number(this.state.confirmDeleteChatterID);

		this.setState({
			confirmDeleteChatterID: 0,
		}, () => {
			this.deleteChatter(chatterID);
		});
	};

	deleteChatter = (chatterIDInput) => {
		const chatterID = Number(chatterIDInput);

		if (!Number.isInteger(chatterID) || chatterID <= 0 || this.isChatterDeleting(chatterID)) {
			return;
		}

		this.setState((prevState) => ({
			openChatterMenuID: 0,
			confirmDeleteChatterID: 0,
			deletingChatterIDs: Array.from(new Set([...prevState.deletingChatterIDs, chatterID])),
			chatterErrorText: '',
		}), () => {
			utils.sendRequest('/chatter/deleteChatter', {
				chatterID,
			})
				.then(() => {
					this.setState((prevState) => ({
						chatterList: prevState.chatterList.filter((chatter) => Number(chatter.chatterId) !== chatterID),
						deletingChatterIDs: prevState.deletingChatterIDs.filter((currentChatterID) => currentChatterID !== chatterID),
					}));
				})
				.catch((error) => {
					console.log('delete chatter error', error);

					this.setState((prevState) => ({
						deletingChatterIDs: prevState.deletingChatterIDs.filter((currentChatterID) => currentChatterID !== chatterID),
						chatterErrorText: error && error.message ? error.message : 'Could not delete the chatter right now.',
					}));
				});
		});
	};

	isReplyChatterDeleting = (replyChatterID) => {
		return (this.state.deletingReplyChatterIDs || []).includes(replyChatterID);
	};

	openDeleteReplyChatterDialog = (reply, parentChatterIDInput) => {
		const replyChatterID = this.getChatterID(reply);
		const parentChatterID = Number(parentChatterIDInput);

		if (!Number.isInteger(replyChatterID) || replyChatterID <= 0 || !Number.isInteger(parentChatterID) || parentChatterID <= 0 || this.isReplyChatterDeleting(replyChatterID)) {
			return;
		}

		this.setState({
			openReplyChatterMenuID: 0,
			confirmDeleteReplyChatterID: replyChatterID,
			confirmDeleteReplyParentChatterID: parentChatterID,
		});
	};

	closeDeleteReplyChatterDialog = () => {
		this.setState({
			confirmDeleteReplyChatterID: 0,
			confirmDeleteReplyParentChatterID: 0,
		});
	};

	onDeleteReplyChatterDialogPrimaryClick = () => {
		const replyChatterID = Number(this.state.confirmDeleteReplyChatterID);
		const parentChatterID = Number(this.state.confirmDeleteReplyParentChatterID);

		this.setState({
			confirmDeleteReplyChatterID: 0,
			confirmDeleteReplyParentChatterID: 0,
		}, () => {
			this.deleteReplyChatter(replyChatterID, parentChatterID);
		});
	};

	deleteReplyChatter = (replyChatterIDInput, parentChatterIDInput) => {
		const replyChatterID = Number(replyChatterIDInput);
		const parentChatterID = Number(parentChatterIDInput);

		if (!Number.isInteger(replyChatterID) || replyChatterID <= 0 || !Number.isInteger(parentChatterID) || parentChatterID <= 0 || this.isReplyChatterDeleting(replyChatterID)) {
			return;
		}

		this.setState((prevState) => ({
			openReplyChatterMenuID: 0,
			deletingReplyChatterIDs: Array.from(new Set([...(prevState.deletingReplyChatterIDs || []), replyChatterID])),
			chatterErrorText: '',
		}), () => {
			utils.sendRequest('/chatter/deleteChatter', {
				chatterID: replyChatterID,
			})
				.then(() => {
					this.setState((prevState) => {
						const nextChatterList = (prevState.chatterList || []).map((chatter) => {
							if (Number(chatter.chatterId) !== parentChatterID) {
								return chatter;
							}

							const nextReplies = (Array.isArray(chatter.replies) ? chatter.replies : []).filter((reply) => Number(reply.chatterId) !== replyChatterID);

							return {
								...chatter,
								replies: nextReplies,
							};
						});

						return {
							chatterList: nextChatterList,
							deletingReplyChatterIDs: (prevState.deletingReplyChatterIDs || []).filter((id) => id !== replyChatterID),
						};
					});
				})
				.catch((error) => {
					console.log('delete reply chatter error', error);

					this.setState((prevState) => ({
						deletingReplyChatterIDs: (prevState.deletingReplyChatterIDs || []).filter((id) => id !== replyChatterID),
						chatterErrorText: error && error.message ? error.message : 'Could not delete the reply right now.',
					}));
				});
		});
	};

	onAddChatterSave = () => {
		const chatterText = (this.state.newChatterText || '').trim();

		if (chatterText === '') {
			this.setState({
				saveChatterErrorText: 'Please enter a message before posting.',
			});
			return;
		}

		this.setState({
			isAddChatterDialogOpen: false,
			isSavingChatter: true,
			openChatterMenuID: 0,
			saveChatterErrorText: '',
			newChatterText: '',
		}, () => {
			utils.sendRequest('/chatter/saveChatter', {
				chatterText,
			})
				.then(() => {
					this.setState({
						isSavingChatter: false,
					});

					this.loadChatterData();
				})
				.catch((error) => {
					console.log('save chatter error', error);
					this.setState({
						isSavingChatter: false,
						saveChatterErrorText: 'Could not add chatter right now. Please try again shortly.',
					});
				});
		});
	};

	renderDeleteChatterDialog = () => {
		const chatterID = Number(this.state.confirmDeleteChatterID);

		if (!Number.isInteger(chatterID) || chatterID <= 0) {
			return null;
		}

		const dialogNode = (
			<HQDialog
				title="Delete Chatter"
				message="Are you sure you want to delete this chatter?"
				primaryButtonText="Delete"
				onPrimaryClick={this.onDeleteChatterDialogPrimaryClick}
				onCancelClick={this.closeDeleteChatterDialog}
				isPrimaryDisabled={this.isChatterDeleting(chatterID)}
			/>
		);

		const portalNode = typeof this.props.getDialogPortalNode === 'function'
			? this.props.getDialogPortalNode()
			: this.props.dialogPortalNode;

		if (portalNode) {
			return ReactDOM.createPortal(dialogNode, portalNode);
		}

		return dialogNode;
	};

	renderAddChatterDialog = () => {
		const {
			isAddChatterDialogOpen,
			newChatterText,
		} = this.state;

		if (!isAddChatterDialogOpen) {
			return null;
		}

		const dialogNode = (
			<div className={styles.dialogOverlay} onClick={this.closeAddChatterDialog}>
				<div className={styles.dialogCard} onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="add-chatter-title">
					<button
						type="button"
						className={styles.dialogCloseButton}
						onClick={this.closeAddChatterDialog}
						aria-label="Close add chatter dialog"
					>
						<FiX />
					</button>

					<h3 id="add-chatter-title" className={styles.dialogTitle}>Add New Chatter</h3>
					<p className={styles.dialogSubtitle}>Share a new update with your network. Keep it short, clear, and useful.</p>

					<textarea
						className={styles.dialogTextarea}
						value={newChatterText}
						onChange={this.onNewChatterTextChange}
						placeholder="Write your chatter here..."
						rows={6}
					/>

					<div className={styles.dialogActions}>
						<button
							type="button"
							className={`${styles.primaryButton} ${styles.dialogPrimaryButton}`}
							onClick={this.onAddChatterSave}
						>
							<FiSend /> Post
						</button>
					</div>
				</div>
			</div>
		);

		const portalNode = typeof this.props.getDialogPortalNode === 'function'
			? this.props.getDialogPortalNode()
			: this.props.dialogPortalNode;

		if (portalNode) {
			return ReactDOM.createPortal(dialogNode, portalNode);
		}

		return dialogNode;
	};

	renderDeleteReplyChatterDialog = () => {
		const replyChatterID = Number(this.state.confirmDeleteReplyChatterID);

		if (!Number.isInteger(replyChatterID) || replyChatterID <= 0) {
			return null;
		}

		const dialogNode = (
			<HQDialog
				title="Delete Reply"
				message="Are you sure you want to delete this reply?"
				primaryButtonText="Delete"
				onPrimaryClick={this.onDeleteReplyChatterDialogPrimaryClick}
				onCancelClick={this.closeDeleteReplyChatterDialog}
				isPrimaryDisabled={this.isReplyChatterDeleting(replyChatterID)}
			/>
		);

		const portalNode = typeof this.props.getDialogPortalNode === 'function'
			? this.props.getDialogPortalNode()
			: this.props.dialogPortalNode;

		if (portalNode) {
			return ReactDOM.createPortal(dialogNode, portalNode);
		}

		return dialogNode;
	};

	renderReplies = (replies, parentChatterID, currentUserID) => {
		if (!Array.isArray(replies) || replies.length === 0) {
			return null;
		}

		return (
			<div className={styles.chatterReplies}>
				{replies.map((reply) => {
					const replyChatterID = this.getChatterID(reply);
					const isReplyMenuOpen = this.state.openReplyChatterMenuID === replyChatterID;
					const canDeleteReplyChatter = Number.isInteger(replyChatterID) && Number(reply.userId) === Number(currentUserID);
					const isReplyChatterDeleting = Number.isInteger(replyChatterID) ? this.isReplyChatterDeleting(replyChatterID) : false;

					return (
					<div key={reply.chatterId} className={styles.chatterReplyCard}>
						<div className={styles.chatterReplyHeader}>
							<div className={styles.chatterReplyAuthor}>
								<div className={styles.chatterReplyAvatar}>{this.getInitials(reply)}</div>
								<div className={styles.chatterReplyIdentity}>
									<p className={styles.chatterReplyName}>{this.getDisplayName(reply)}</p>
									<p className={styles.chatterReplyMeta}>{this.formatChatterTimestamp(reply.createdAt)}</p>
								</div>
							</div>
							{canDeleteReplyChatter && (
								<div className={styles.updateActions} ref={(node) => this.setReplyChatterMenuRef(replyChatterID, node)}>
									<button
										type="button"
										className={styles.updateMenuButton}
										onClick={() => this.toggleReplyChatterMenu(replyChatterID)}
										aria-label="Open reply actions"
										aria-expanded={isReplyMenuOpen}
										disabled={isReplyChatterDeleting}
									>
										<FiMoreVertical />
									</button>

									{isReplyMenuOpen && (
										<div className={styles.updateMenu} role="menu" aria-label="Reply actions">
											<button
												type="button"
												className={styles.updateMenuItemDelete}
												onClick={() => this.openDeleteReplyChatterDialog(reply, parentChatterID)}
												disabled={isReplyChatterDeleting}
												role="menuitem"
											>
												Delete
											</button>
										</div>
									)}
								</div>
							)}
						</div>

						<p className={styles.chatterReplyBody}>{reply.chatterText || 'Reply not available.'}</p>
					</div>
				);
				})}
			</div>
		);
	};

	render() {
		const {
			isLoadingChatters,
			isLoadingMoreChatters,
			isSavingChatter,
			isSendingReplyIDs,
			chatterErrorText,
			saveChatterErrorText,
			chatterList,
			openChatterMenuID,
			openReplyComposerID,
			replyTextByChatterID,
			hasMoreChatters,
		} = this.state;

		const currentUserID = utils.getCurrentUserID();

		return (
			<>
				<div className={styles.sectionHeader}>
					<h2 className={styles.formTitle}><FiMessageSquare /> Chatter</h2>
					<p className={styles.formText}>Short posts about anything you want to share.</p>
					{isSavingChatter && <div className={styles.statusText}>Posting your chatter</div>}
				</div>

				{chatterErrorText !== '' && <div className={styles.errorBox}>{chatterErrorText}</div>}
				{saveChatterErrorText !== '' && <div className={styles.errorBox}>{saveChatterErrorText}</div>}

				{isLoadingChatters && <div className={styles.loadingBox}>Loading chatter feed...</div>}

				{!isLoadingChatters && chatterList.length === 0 && (
					<div className={styles.emptyBox}>No chatter posts were found for this profile.</div>
				)}

				{!isLoadingChatters && chatterList.length > 0 && (
					<div className={styles.profileList}>
						{chatterList.map((item) => {
							const chatterID = this.getChatterID(item);
							const isMenuOpen = openChatterMenuID === chatterID;
							const isReplyComposerOpen = openReplyComposerID === chatterID;
							const canDeleteChatter = Number.isInteger(chatterID) && Number(item.userId) === currentUserID;
							const isDeletingChatter = Number.isInteger(chatterID) ? this.isChatterDeleting(chatterID) : false;
							const isReplySending = Number.isInteger(chatterID) ? this.isReplySending(chatterID) : false;
							const replies = Array.isArray(item.replies) ? item.replies : [];
							const replyText = Number.isInteger(chatterID) ? (replyTextByChatterID[chatterID] || '') : '';

							return (
								<article key={item.chatterId} className={`${styles.profileCard}${isDeletingChatter ? ` ${styles.updateCardDeleting}` : ''}`}>
									<div className={styles.profileCardHeader}>
										<div className={styles.chatterAuthorGroup}>
											<div className={styles.chatterAvatar}>{this.getInitials(item)}</div>
											<div className={styles.profileCardHeadingGroup}>
												<h3 className={styles.profileCardTitle}>{this.getDisplayName(item)}</h3>
												<p className={styles.profileCardSubtitle}><FiCalendar /> {this.formatChatterTimestamp(item.createdAt)}</p>
											</div>
										</div>
										{canDeleteChatter && (
											<div className={styles.updateActions} ref={(node) => this.setChatterMenuRef(chatterID, node)}>
												<button
													type="button"
													className={styles.updateMenuButton}
													onClick={() => this.toggleChatterMenu(chatterID)}
													aria-label="Open chatter actions"
													aria-expanded={isMenuOpen}
													disabled={isDeletingChatter}
												>
														<FiMoreVertical />
													</button>

												{isMenuOpen && (
													<div className={styles.updateMenu} role="menu" aria-label="Chatter actions">
														<button
															type="button"
															className={styles.updateMenuItemDelete}
															onClick={() => this.openDeleteChatterDialog(item)}
															disabled={isDeletingChatter}
															role="menuitem"
														>
															Delete
														</button>
													</div>
											)}
										</div>
									)}
								</div>

								<p className={`${styles.profileCardBody} ${styles.chatterCardBody}`}>{item.chatterText || 'No chatter text provided.'}</p>

								<div className={styles.profileCardMetaRow}>
									<span className={styles.profileCardMetaChip}><FiUser /> {replies.length} replies</span>
									{Number.isInteger(chatterID) && (
										<button
											type="button"
											className={styles.chatterReplyButton}
											onClick={() => this.toggleReplyComposer(chatterID)}
											disabled={isReplySending}
										>
											{isReplyComposerOpen ? 'Cancel Reply' : 'Reply'}
										</button>
									)}
								</div>

								{isReplyComposerOpen && Number.isInteger(chatterID) && (
									<div className={styles.chatterReplyComposer}>
										<textarea
											className={styles.dialogTextarea}
											value={replyText}
											onChange={(event) => this.onReplyTextChange(chatterID, event)}
											placeholder="Write your reply..."
											rows={3}
										/>
										<div className={styles.chatterReplyComposerActions}>
											<button
												type="button"
												className={styles.primaryButton}
												onClick={() => this.onReplySend(item)}
												disabled={isReplySending}
											>
												{isReplySending ? 'Sending...' : 'Send Reply'}
											</button>
										</div>
									</div>
								)}

								{this.renderReplies(replies, chatterID, currentUserID)}
							</article>
						);
						})}
					</div>
				)}

				{hasMoreChatters && (
					<div className={styles.sectionFooterActions}>
						<button
							type="button"
							className={styles.loadMoreButton}
							onClick={this.loadMoreChatters}
							disabled={isLoadingMoreChatters}
						>
							{isLoadingMoreChatters ? 'Loading more...' : 'Load More Chatters'}
						</button>
					</div>
				)}

				<div className={styles.sectionFooterActions}>
					<button
						type="button"
						className={styles.secondaryButton}
						onClick={this.openAddChatterDialog}
					>
						<FiPlus /> Add Chatter
					</button>
				</div>

				{this.renderDeleteChatterDialog()}
				{this.renderDeleteReplyChatterDialog()}
				{this.renderAddChatterDialog()}
			</>
		);
	}
}
